import React, { useEffect, useState } from "react";
import { Text } from "src/components/ui/Text";
import EvMenuBtn from "src/components/widgets/widget_layouts/EvWidget/icons/evMenu";
import { useDempStore } from "src/context/stores";
import {
  OnlineIcon,
  OfflineIcon,
  ChargingIcon,
  AccidentIcon,
  BatteryLowIcon,
  CancelIcon,
  NoReportIcon,
} from "../icons";
import SearchBarReport from "./SearchBarReport";
import ReportLists from "./ReportLists";
import { useCompanyReportDeviceLists } from "src/api/company";
import DisplayViewDate from "./DisplayViewDate";
import BtnDownloadCSV from "./BtnDownloadCSV";
import { WidgetLoading } from "src/components/ui";
import { useTHPStore } from "src/context/stores";
import MultiSearchBar from "./MultiSearchBar";
import { useTranslation } from 'react-i18next'
import BtnVehicleReport from "./BtnVehicleReport";
import BtnChargerReport from "./BtnChargerReport";
import BtnYearlyReport from "./BtnYearlyReport";

const THPReport = () => {
  const [plantId] = useDempStore((state) => [state.plantId]);
  const [dataReport, setDataReport] = useState([]);
  const { infoView, setInfoView} = useTHPStore()
  // const [infoView, setInfoView] = useState("truck");
  const [showInfo, setShowInfo] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [groupSearch, setGroupSearch] = useState([]);
  const [dropdownGroupSearch, setDropdownGroupSearch] = useState([]);
  const [groupSelectStatus, setGroupSelectStatus] = useState([]);
  const { t } = useTranslation("settings");


  //   set global time range
  const [selectedRange, setSelectedRange] = useState("?start=-1d&stop=now()");

  const { data:reportDataList, isLoadingData: isLoadingReport, isErrorData } = useCompanyReportDeviceLists(
    plantId,
    infoView === "truck" ? "vehicle" : "charger",
    selectedRange,
    groupSelectStatus
  );

  useEffect(() => {
    if (reportDataList) {
      const listDropdownSearch = reportDataList?.map((list) => list?.device);

      setDropdownGroupSearch(listDropdownSearch);
    }
  }, [reportDataList]);

  useEffect(() => {
    if (reportDataList) {
      if (groupSearch.length > 0) {
        // TODO : When api have a search data remove condition filterSearch and listDropdownSearch
        // const filterGroupSearch = reportDataList?.filter((list) =>
        //   groupSearch
        //     ?.map((word) => {
        //       return word?.toLowerCase()?.trim()?.replaceAll(" ", "");
        //     })
        //     .includes(list?.device?.toLowerCase()?.trim()?.replaceAll(" ", ""))
        // );

        // setDataReport(filterGroupSearch);
        
      } else {
        setDataReport(reportDataList);
      }
    }
  }, [reportDataList, groupSearch]);

  useEffect(() => {
    setGroupSelectStatus([]);
  }, [infoView]);

  const handleViewChange = (type) => {
    setInfoView(type);

    if (type === "truck") {
      setGroupSearch([]);
    } else {
      setGroupSearch([]);
    }
  };

  // console.log(dataReport,reportDataList,groupSearch);
  

  return (
    <div className={`w-full ${ dataReport?.length > 0 ? "min-h-[calc(100vh-7.125rem)]" : "h-[calc(100vh-7.125rem)]"} py-5 pl-6 pr-5 flex flex-col gap-4`}>
      {/* btn Go Back */}
      {/* <div className="flex">
        <div className="flex gap-2 p-3 rounded-lg cursor-pointer hover:bg-quartenary/30">
          <ArrowLeftIcon />
          <Text variant="semi-12" className="text-green">
            Back to Dashboard/EV
          </Text>
        </div>
      </div> */}

      {/* paper content report */}
      <div className="flex flex-col w-full h-full gap-4 p-4 bg-white rounded-lg shadow-content-box">
        {/* title name content report */}
        <div className="flex items-center justify-between gap-2">
          <div>
            <Text variant="bold-20">{t('report.title')}</Text>
            <Text variant="normal-14" className="text-secondary">
            {t('report.description')}
            </Text>
          </div>

          <div className="flex gap-2">
            <BtnYearlyReport />
            {infoView === "charger" && <BtnChargerReport selectedRange={selectedRange} />}
            {infoView === "truck" && <BtnVehicleReport selectedRange={selectedRange} />}
            <BtnDownloadCSV />
          </div>
        </div>

        {/* filter content report */}
        <div className="grid grid-cols-2 auto-rows-max">
          {/* filter and search bar */}
          <div className="flex items-center gap-2">
            {/* btn filter category */}
            <div className="h-8">
              <EvMenuBtn setView={handleViewChange} type="info" />
            </div>

            {/* search bar */}
            {/* <SearchBarReport
              searchInput={searchInput}
              setSearchInput={setSearchInput}
              dropdownGroupSearch={dropdownGroupSearch}
              groupSearch={groupSearch}
              setGroupSearch={setGroupSearch}
            /> */}

            <MultiSearchBar 
              searchInput={searchInput}
              setSearchInput={setSearchInput}
              dropdownGroupSearch={dropdownGroupSearch}
              groupSearch={groupSearch}
              setGroupSearch={setGroupSearch}
              reportDataList={reportDataList}
              setDataReport={setDataReport}
              />

          </div>

          {/* display view  */}
          <div className="flex justify-end">
            <DisplayViewDate
              selectedRange={selectedRange}
              setSelectedRange={setSelectedRange}
            />
          </div>
        </div>

        {/* filter status */}
        <div className="flex items-center gap-2">
          {/* btn status */}
          <div className="flex items-center gap-2">
            <Text variant="normal-14" className="w-[3.8rem] text-secondary">
            {t('settings:report.status.title')}:
            </Text>

            <div className="flex gap-2">
              {infoView === "truck"
                ? groupStatusVehicle?.map(({ name, id, value }) => {
                    return (
                      <div key={name}>
                        <BtnStatus
                          name={name}
                          id={id}
                          value={value}
                          groupStatusId={groupSelectStatus}
                          setGroupStatusId={setGroupSelectStatus}
                        />
                      </div>
                    );
                  })
                : groupStatusCharger?.map(({ name, id, value }) => {
                    return (
                      <div key={name}>
                        <BtnStatus
                          name={name}
                          id={id}
                          value={value}
                          groupStatusId={groupSelectStatus}
                          setGroupStatusId={setGroupSelectStatus}
                        />
                      </div>
                    );
                  })}
            </div>
          </div>

          {/* btn switch */}
          <div className="flex items-center h-full gap-2 px-2 border-l border-r border-quartenary">
            <BtnShowInfo showInfo={showInfo} setShowInfo={setShowInfo} />

            <Text variant="bold-14" className="text-vekin-green100">
              {infoView === "truck"
                ? t('settings:report.show_vehicle')
                : t('settings:report.show_station')}
            </Text>
          </div>
        </div>

        {/* table lists content report */}
        <div className="flex flex-col h-full gap-4 pt-4 border-t border-tertiary">
          {/* Search list */}
          <div className="flex items-center gap-2">
            <div className="flex items-center h-7">
              <Text variant="normal-14" className="text-secondary w-[7.5rem]">
              {t('settings:report.search_list')}:
              </Text>
            </div>

            {/* <div className="flex gap-2">
              {groupSearch?.length > 0 &&
                groupSearch?.map((word, index) => {
                  return (
                    <div key={`${word} ${index}`}>
                      <BtnSearchList
                        word={word}
                        groupSearch={groupSearch}
                        setGroupSearch={setGroupSearch}
                      />
                    </div>
                  );
                })}
            </div> */}
          </div>

          <div className={`${dataReport?.length > 0 ? "" : "h-full"} `}>
          {dataReport?.length > 0 &&    
          <ReportLists
                data={dataReport}
                infoView={infoView}
                showInfo={showInfo}
                groupSelectStatus={groupSelectStatus}
                selectedRange={selectedRange}
              /> }

            {!isLoadingReport && !reportDataList && isErrorData && 
                      <div className="flex flex-col items-center justify-center w-full h-full gap-4">
                      <NoReportIcon />
                      <Text variant="bold-16" className="text-black">
                      {t('settings:report.no_report')}
                      </Text>
                    </div>
            }

            {isLoadingReport && !reportDataList &&
              <div className="flex flex-col items-center justify-center w-full h-full gap-4">
                <WidgetLoading text={t('settings:report.loading_report')}/>
            </div>
            }

          </div>
        </div>
      </div>
    </div>
  );
};

export default THPReport;

const groupStatusVehicle = [
  {
    name: "All",
    value: "all",
    id: 0,
  },
  {
    name: "Driving",
    value: "driving",
    id: 1,
  },
  {
    name: "Charging",
    value: "charging",
    id: 2,
  },
  {
    name:  "Parking",
    value: "parking",
    id: 3,
  },
];

const groupStatusCharger = [
  {
    name: "All",
    value: "all",
    id: 0,
  },
  {
    name: "Standby",
    value: "standby",
    id: 1,
  },
  {
    name: "Charging",
    value: "charging",
    id: 2,
  },
  {
    name: "Active",
    value: "active",
    id: 3,
  },
  {
    name: "Fail",
    value: "fail",
    id: 4,
  },
  {
    name: "Finishing",
    value: "finishing",
    id: 5,
  },
];

const BtnStatus = ({ name, id, value, groupStatusId, setGroupStatusId }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (groupStatusId?.length === 0 && id === 0) {
      setIsActive(true);
    }
    if (groupStatusId?.length > 0 && id === 0) {
      setIsActive(false);
    }

    if (groupStatusId?.length === 0 && id !== 0) {
      setIsActive(false);
    }

    if (id !== 0 && groupStatusId.includes(id)) {
      setIsActive(true);
    }
  }, [groupStatusId?.length, id, groupStatusId]);

  const icon = (id) => {
    switch (id) {
      case 1:
        return <OnlineIcon />;
      case 2:
        return <ChargingIcon />;
      case 3:
        return <OfflineIcon />;
      case 4:
        return <AccidentIcon />;
      case 5:
        return <BatteryLowIcon />;

      default:
        <div></div>;
    }
  };

  const onClick = () => {
    if (id === 0) {
      setGroupStatusId([]);
    }
    if (id !== 0 && !isActive) {
      setIsActive(true);
      setGroupStatusId([...groupStatusId, value]);
    }

    if (id !== 0 && isActive) {
      const removeGroupStatusId = groupStatusId?.filter(
        (list) => list !== value
      );

      setIsActive(false);
      setGroupStatusId([...removeGroupStatusId]);
    }
  };

  return (
    <button
      className={`flex gap-1 items-center px-2 py-[0.375rem] border border-quartenary rounded-3xl h-7 ${
        isActive
          ? "border-vekin-green100 bg-vekin-green-50"
          : "hover:border-vekin-green100/40"
      }`}
      onClick={onClick}
    >
      {icon(id)}
      <Text
        variant={isActive ? "bold-12" : "medium-12"}
        className={`text-secondary ${isActive && "text-vekin-green100"}`}
      >
        {name}
      </Text>
    </button>
  );
};

const BtnSearchList = ({ word, groupSearch, setGroupSearch }) => {
  const onClick = () => {
    if (groupSearch.includes(word)) {
      const indexGroupSearch = groupSearch?.indexOf(word);
      groupSearch?.splice(indexGroupSearch, 1);

      setGroupSearch([...groupSearch]);
    }
  };
  return (
    <button
      className={`flex gap-1 items-center px-2 py-[0.375rem] border border-vekin-green100 bg-vekin-green-50 rounded-3xl h-7`}
    >
      <Text variant="bold-12" className={`text-vekin-green100`}>
        {word}
      </Text>

      <div onClick={onClick}>
        <CancelIcon />
      </div>
    </button>
  );
};

const BtnShowInfo = ({ showInfo, setShowInfo }) => {
  return (
    <button
      className={`w-12 h-8 rounded-[3rem] px-1 py-[0.1875rem] shadow-content-box ${
        showInfo
          ? "border border-vekin-green60 bg-gradient-to-br from-vekin-green-40 to-vekin-green100"
          : "border border-quartenary bg-gradient-to-tr from-quartenary to-quartenary"
      }`}
      onClick={() => setShowInfo(!showInfo)}
    >
      <div
        className={`w-6 h-6 bg-white rounded-full ${
          showInfo
            ? "translate-x-[0.875rem] transition delay-50"
            : "transition delay-50"
        }`}
      ></div>
    </button>
  );
};
